import { TTrafficTypes } from '../model/types';

export const trafficTypes: TTrafficTypes[] = ['ftd', 'std', 'mix', 'vip'];
